import axios from "../../utils/axios";

export const getRelatedBlog = async (id, tags) => {
  const quary =
    tags?.length > 0
      ? tags.map((tag) => `tags_like=${tag}`).join("&") + `&id_ne=${id}`
      : `id_ne=${id}`;

  const response = await axios.get(`/blogs?${quary}`);

  return response.data;
};
